"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SELECTION_TYPE = exports.ContentContainer = exports.Alignment = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _accordion = require("./accordion.tokens");
var _flex = require("../../layout/flex");
var _FlexItem = require("../../layout/flex/FlexItem");
var _Icon = require("../../media/icon/Icon");
var _Label = _interopRequireDefault(require("../../text/Label"));
var _Text = _interopRequireDefault(require("../../text/Text"));
var _globalTokens = require("../../../shared/global-tokens");
var AccordionPrimitive = _interopRequireWildcard(require("@radix-ui/react-accordion"));
var _IconTooltip = _interopRequireDefault(require("../../feedback/tooltip/IconTooltip"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var Alignment = exports.Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["LEFT"] = "left";
  Alignment["RIGHT"] = "right";
  return Alignment;
}({});
var SELECTION_TYPE = exports.SELECTION_TYPE = /*#__PURE__*/function (SELECTION_TYPE) {
  SELECTION_TYPE["SINGLE"] = "single";
  SELECTION_TYPE["MULTIPLE"] = "multiple";
  return SELECTION_TYPE;
}({});
var StyledAccordionPrimitive = (0, _styledComponents.default)(AccordionPrimitive.Root).withConfig({
  displayName: "Accordion__StyledAccordionPrimitive",
  componentId: "sc-1m32mzx-0"
})(["display:flex;flex-direction:column;", ";", " div[data-type='chevron']{padding:", ";}"], function (_ref) {
  var $background = _ref.$background;
  return $background ? "row-gap: ".concat(_globalTokens.globalSpacing['100']) : '';
}, function (_ref2) {
  var $group = _ref2.$group,
    $background = _ref2.$background,
    $border = _ref2.$border;
  return !$background && ($group || $border) ? (0, _styledComponents.css)(["", ";border-radius:", ";"], _accordion.tokens.border.background, _globalTokens.globalBorder.radius['2']) : (0, _styledComponents.css)([""]);
}, _globalTokens.globalSpacing['300']);
var StyledAccordionHeader = (0, _styledComponents.default)(AccordionPrimitive.Header).withConfig({
  displayName: "Accordion__StyledAccordionHeader",
  componentId: "sc-1m32mzx-1"
})([""]);
var StyledAccordionTrigger = (0, _styledComponents.default)(AccordionPrimitive.Trigger).withConfig({
  displayName: "Accordion__StyledAccordionTrigger",
  componentId: "sc-1m32mzx-2"
})(["display:flex;flex-grow:1;flex-direction:row;align-items:center;justify-content:space-between;padding:", ";background:", ";", ";border-radius:", ";cursor:pointer;height:", ";&:focus-visible{outline:none;", ";}&:hover{background:", ";}&:disabled{background:", ";}&[data-state='open']{[data-type='chevron'] svg{transform:rotate(-180deg);}}"], _globalTokens.globalSpacing['200'], function (_ref3) {
  var $background = _ref3.$background;
  return $background ? _accordion.tokens.background.default : 'none';
}, function (_ref4) {
  var $background = _ref4.$background,
    $border = _ref4.$border;
  return $background && !$border ? _accordion.tokens.border.background : _accordion.tokens.border.noBackground;
}, function (_ref5) {
  var $background = _ref5.$background;
  return $background ? _globalTokens.globalBorder.radius['2'] : 0;
}, _tokens.default.sky.ref.unit['1600'], _globalTokens.globalShadow.focusRing, _accordion.tokens.background.hover, function (_ref6) {
  var $background = _ref6.$background;
  return $background ? _accordion.tokens.background.disabled : 'none';
});
var StyledAccordionItem = (0, _styledComponents.default)(AccordionPrimitive.Item).withConfig({
  displayName: "Accordion__StyledAccordionItem",
  componentId: "sc-1m32mzx-3"
})(["display:flex;flex-direction:column;", ""], function (_ref7) {
  var $group = _ref7.$group,
    $background = _ref7.$background,
    $border = _ref7.$border;
  return $background ? $border ? (0, _styledComponents.css)(["", ";border-radius:", ";&[data-state='closed']{border-bottom:0;}"], _accordion.tokens.border.background, _globalTokens.globalBorder.radius['2']) : '' : $group || $border ? (0, _styledComponents.css)(["&:first-child > button{border-top-right-radius:", ";border-top-left-radius:", ";}&[data-state='open']:last-child > div,&[data-state='closed']:last-child > button{border-bottom:0;border-bottom-right-radius:", ";border-bottom-left-radius:", ";}"], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['100']) : "";
});
var StyledAccordionContent = (0, _styledComponents.default)(AccordionPrimitive.Content).withConfig({
  displayName: "Accordion__StyledAccordionContent",
  componentId: "sc-1m32mzx-4"
})(["padding:", ";overflow:hidden;", ";"], _globalTokens.globalSpacing['400'], function (_ref8) {
  var $background = _ref8.$background;
  return !$background ? _accordion.tokens.border.noBackground : '';
});
var DefaultAccordionContext = {
  background: true,
  border: false,
  group: false,
  disabled: false
};
var AccordionContext = /*#__PURE__*/(0, _react.createContext)(DefaultAccordionContext);
var ChevronIcon = function ChevronIcon(_ref9) {
  var color = _ref9.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    "data-type": 'chevron',
    icon: 'chevronDown',
    color: color,
    size: 'm',
    "aria-hidden": true
  });
};
var ContentContainer = function ContentContainer(_ref10) {
  var stacked = _ref10.stacked,
    children = _ref10.children;
  return stacked ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_flex.FlexColumn, {
    alignItems: 'START',
    gap: 's',
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_flex.FlexRow, {
    columnGap: 'm',
    children: children
  });
};
exports.ContentContainer = ContentContainer;
var Item = function Item(_ref11) {
  var children = _ref11.children,
    label = _ref11.label,
    content = _ref11.content,
    _ref11$alignment = _ref11.alignment,
    alignment = _ref11$alignment === void 0 ? Alignment.LEFT : _ref11$alignment,
    _ref11$contentAlignme = _ref11.contentAlignment,
    contentAlignment = _ref11$contentAlignme === void 0 ? Alignment.LEFT : _ref11$contentAlignme,
    _ref11$stacked = _ref11.stacked,
    stacked = _ref11$stacked === void 0 ? false : _ref11$stacked,
    value = _ref11.value,
    tooltip = _ref11.tooltip;
  var context = (0, _react.useContext)(AccordionContext);
  var background = context.background,
    group = context.group,
    border = context.border,
    disabled = context.disabled;
  var color = disabled ? background ? 'disabledOnDisabled' : 'disabled' : 'default';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledAccordionItem, {
    value: value || label,
    $background: background,
    $border: border,
    $group: group,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionHeader, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionTrigger, {
        $background: background,
        $border: border,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flex.FlexRow, {
          columnGap: 's',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
            children: alignment === Alignment.LEFT && /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronIcon, {
              color: color
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentContainer, {
            stacked: stacked,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexItem.FlexItem, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, {
                color: color,
                children: label
              }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
                iconSize: 'm',
                children: tooltip
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
              flexGrow: '1',
              justifyContent: contentAlignment === Alignment.LEFT ? _flex.FLEX_ALIGN_ITEMS.START : _flex.FLEX_ALIGN_ITEMS.END,
              children: content && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                color: color,
                children: content
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
            children: alignment === Alignment.RIGHT && /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronIcon, {
              color: color
            })
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionContent, {
      $background: background,
      children: children
    })]
  });
};
var Accordion = function Accordion(_ref12) {
  var children = _ref12.children,
    _ref12$background = _ref12.background,
    background = _ref12$background === void 0 ? true : _ref12$background,
    _ref12$border = _ref12.border,
    border = _ref12$border === void 0 ? false : _ref12$border,
    _ref12$selectionType = _ref12.selectionType,
    selectionType = _ref12$selectionType === void 0 ? SELECTION_TYPE.MULTIPLE : _ref12$selectionType,
    _ref12$disabled = _ref12.disabled,
    disabled = _ref12$disabled === void 0 ? false : _ref12$disabled,
    _ref12$collapsible = _ref12.collapsible,
    collapsible = _ref12$collapsible === void 0 ? false : _ref12$collapsible,
    defaultValue = _ref12.defaultValue,
    _ref12$onOpen = _ref12.onOpen,
    onOpen = _ref12$onOpen === void 0 ? function () {
      return undefined;
    } : _ref12$onOpen,
    _ref12$onClose = _ref12.onClose,
    onClose = _ref12$onClose === void 0 ? function () {
      return undefined;
    } : _ref12$onClose;
  var group = Array.isArray(children) && children.length > 1;
  var _ref13 = (0, _react.useState)(defaultValue ? [defaultValue] : []),
    _ref14 = _slicedToArray(_ref13, 2),
    setOpenedKeys = _ref14[1];
  var _onValueChange = function onValueChange(values) {
    setOpenedKeys(function (previousOpenedKeys) {
      var openedValue = values.find(function (x) {
        return !previousOpenedKeys.includes(x);
      });
      if (openedValue) {
        onOpen(openedValue);
      } else {
        var closedValue = previousOpenedKeys.find(function (x) {
          return !values.includes(x);
        });
        if (closedValue) {
          onClose(closedValue);
        }
      }
      return values;
    });
  };
  var extraProps;
  if (selectionType === SELECTION_TYPE.MULTIPLE) {
    extraProps = {
      defaultValue: defaultValue ? [defaultValue] : undefined,
      onValueChange: function onValueChange(values) {
        return _onValueChange(values);
      }
    };
  } else {
    extraProps = {
      defaultValue: defaultValue,
      onValueChange: function onValueChange(value) {
        return _onValueChange([value]);
      }
    };
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionPrimitive, _objectSpread({
    $group: group,
    $background: background,
    $border: border,
    type: selectionType,
    disabled: disabled,
    collapsible: collapsible
  }, extraProps, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AccordionContext.Provider, {
      value: {
        background: background,
        group: group,
        border: border,
        disabled: disabled
      },
      children: children
    })
  }));
};
Accordion.Item = Item;
Item.Alignment = Alignment;
Accordion.Alignment = Alignment;
Accordion.SelectionType = SELECTION_TYPE;
var _default = exports.default = Accordion;